'use client';

export default function DemoVideo() {
  return (
    <>
      <div style={{ width: '80vw', height: '80vh', overflow: 'hidden' }}>
        <iframe
          title="YouTube Video"
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/XMEWkv2gMCc"
          allowFullScreen
        ></iframe>
      </div>
    </>
  );
}
